module.exports = __webpack_public_path__ + "static/img/nothing.c5a3045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Upload/nothing.png
// module id = oBXE
// module chunks = 19